export enum aiPictureActions {
    FETCH_AI_PICTURES_REQUEST = 'FETCH_AI_PICTURES_REQUEST',
    CREATE_AI_PICTURES_REQUEST = 'CREATE_AI_PICTURES_REQUEST',
    SET_AI_PICTURES = 'SET_AI_PICTURES',
}
